import { Components } from "@thisgorilla/primate-ds";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";

import { CreatePostModalContext } from "../..";
import { API_CALLS } from "../../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../../redux";
import { ImageUploadProps } from "./ImageUpload";

const ReUploadButton = ({ file, id, size }: ImageUploadProps.Reupload) => {
  const [progress, setProgress] = useState(0);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const { post_id } = useAppSelector((state) => state.posts);
  const { setImageUploadOpen, setIsMoreImgUploadButtonDisable } = useContext(
    CreatePostModalContext
  );
  let timer: NodeJS.Timer;

  useEffect(() => {
    if (!isImageUploading) {
      setProgress(100);
      clearInterval(timer);
    }
    //eslint-disable-next-line
  }, [isImageUploading]);

  return (
    <ReUploadButtonContainer>
      <Container>
        <Components.IconButton
          disabled={false}
          iconType="ArrowUp"
          kind="Opacity"
          onClick={() => {
            setProgress(0);
            API_CALLS.POSTS.uploadsImageForAPost(
              {
                post_id,
                images: [{ file, id }],
              },
              setImageUploadOpen,
              setIsMoreImgUploadButtonDisable,
              setIsImageUploading
            );

            timer = setInterval(() => {
              setProgress((prev) => (prev < 90 ? prev + 10 : prev));
            }, 200);
          }}
          size={size}
        />
        {isImageUploading && <BackDrop $progress={progress} />}
      </Container>
    </ReUploadButtonContainer>
  );
};

export default ReUploadButton;

const ReUploadButtonContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  inset: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
  & > div > button {
    box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-m"]};
  }
`;

const BackDrop = styled.div<{ $progress: number }>`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: ${({ $progress }) => $progress}%;
  background: ${({ theme }) => theme.Color.icon.brand.subtle.default.value};
  border-radius: 0px 0px 4px 4px;
  transition: height 700ms ease;
`;

const Container = styled.div`
  position: relative;
`;
